module.exports = __webpack_public_path__ + "static/media/pedgog.2a835ee7.svg";